import { render, staticRenderFns } from "./CoverSheet.vue?vue&type=template&id=43bf6591&scoped=true"
import script from "./CoverSheet.vue?vue&type=script&lang=ts"
export * from "./CoverSheet.vue?vue&type=script&lang=ts"
import style0 from "./CoverSheet.vue?vue&type=style&index=0&id=43bf6591&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf6591",
  null
  
)

export default component.exports